// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1Ton_","userZone":"Header_userZone__3pPKY","logo":"Header_logo__1DY8Q"};